<template>
  <PageBlocked v-if="isBlocked" :blockRole="blockRole"/>
  <div v-else class="d-flex flex-column">
    <div class="date-wrapper">
      <v-skeleton-loader
          v-if="isLoading && dateListLoading"
          max-width="555"
          width="100%"
          height="156"
          type="image"
          v-bind="attrs"
      >
      </v-skeleton-loader>
      <div class="date-wrapper__filters" v-else>
        <AgendaDateStrip
            ref="agendaDateStrip"
            v-if="isAgendaDateStrip"
            :isStart="eventStart"
            :isEnd="eventEnd"
            :dateListEvent="dateListEvent"
            :modelValue="agendaIsoDay"
            @update:modelValue="onPickDay"
            :timezoneUtc="eventTimezoneUtc"
        />
        <FilterChipButtons
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
            :useContentAsKey="true"
            @handleSearch="handleSearch"
        />
      </div>

    </div>

    <div v-if="filterModalIsVisible">
      <FilterModal
          :filterModalIsVisible="filterModalIsVisible"
          :currentModalFilter="currentModalFilter"
          :currentModalLabel="currentModalLabel"
          :selectedChips="selectedChips"
          :filters="filters"
          :dateError="date.error"
          :dateOption="date.option"
          :dateRange="date.selectedRange"
          @closeModal="closeModal"
          @applySelection="applySelection"
          @setItem="setItem"
          :isStart="eventStart"
          :isEnd="eventEnd"
          @setDateDay="setDateDay"
          :dateListEvent="dateListEvent"
      />
    </div>
    <Banner :style="{marginBottom: isSearch ? '0px' : '20px'}" class="mt-5" v-if="banner && !isLoading" :banner="banner" />
    <v-skeleton-loader
        v-if="isLoading"
        v-bind="attrs"
        max-width="555"
        height="600"
        width="100%"
        type="card, list-item-three-line"
        class="mt-12"
    />
    <div class="d-flex flex-column" v-else>
      <div class="agenda-page__not-found" v-if="!agendaEvent.length">
        <span
            class="agenda-page__not-found__text"
            v-if="!hasSearchText"
        >
          No sessions scheduled for this day.
        </span>
        <span v-else class="agenda-page__not-found__text">
          No results found
        </span>
      </div>
      <div v-for="{ isoDay, date, data } in agendaSessions" :key="isoDay">
        <div v-if="isSearch" class="agenda-page__title">
          {{ date }}
        </div>
        <div v-for="(agenda, index) in data" :key="index">
          <AgendaCard :agenda-event="agenda" />
        </div>
      </div>
      <div
          class="d-flex my-9 justify-center home-page__pagination"
          v-if="agendaEvent.length > 0"
      >
        <v-pagination
            color="#F2F2F2"
            :total-visible="10"
            circle
            v-model="filters.page"
            @input="(e) => onPageChange(e)"
            :length="+this.pageCountAgendas"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AgendaCard from '@/components/Event/AgendaCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Dwh from '@/mixins/Dwh'
import EventDescription from '@/components/Event/EventDescription.vue'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'
import Banner from '@/components/Banner'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import AgendaDateStrip from '@/components/AgendaDateStrip.vue'
import { parseTimezoneOffset,formatEventDayLabel, utcTsToIsoDayInEventTz} from '@/utils/eventDate'


export default {
  name: 'AgendasPage',
  mixins: [Dwh, Filter,Block],
  components: {
    FilterChipButtons,
    EventDescription,
    AgendaCard,
    NewsFeedEmpty,
    FilterModal,
    Banner,
    PageBlocked,
    AgendaDateStrip
  },
  watch: {
    agendaIsoDay() {
      this.tryFetchAgenda()
    },
    eventTimezoneUtc() {
      this.tryFetchAgenda()
    }
  },
  methods: {
    ...mapActions('event', ['getEventTracks', 'clearEventTracks', 'getEvent','getEventDateList','speakerClear']),
    ...mapActions('advertisement', ['getBanner', 'clearBanner']),
    ...mapActions('list', ['getSortType']),
    ...mapActions('app', ['setPageTitle']),
    tryFetchAgenda() {
      if (!this.agendaIsoDay) return
      if (!this.eventTimezoneUtc) return
      if (!this.eventStart || !this.eventEnd) return

      this.getAgendaEvent(this.requestQuery)
    },
    setDateDay(date) {
      this.agendaIsoDay = date
      this.$nextTick(() => {
        if (this.$refs.agendaDateStrip) {
          this.$refs.agendaDateStrip.scrollToActive()
        }
      })
    },
    handleSearch(search){
      this.isSearch = search
    },
    onPickDay(iso) {
      if(this.date){
        this.date = {
          selectedRange: {
            from: null,
            to: null,
          },
          option: null,
          error: '',
        }
      }
      this.agendaIsoDay = iso
      this.getFilteredItems()
    },
    buildAgendaTimeQuery() {
      if (!this.agendaIsoDay) return ''

      const tz = this.eventTimezoneUtc || 'UTC+0'
      const offsetSec = parseTimezoneOffset(tz)
      const [y, m, d] = this.agendaIsoDay.split('-').map(Number)
      const fromUtc = Date.UTC(y, m - 1, d, 0, 0, 0) - offsetSec * 1000
      const toUtc   = Date.UTC(y, m - 1, d, 23, 59, 59) - offsetSec * 1000

      const fromTs = Math.floor(fromUtc / 1000)
      const toTs   = Math.floor(toUtc / 1000)

      return `&from_timestamp=${fromTs}&to_timestamp=${toTs}`
    },
    todayISO() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
  },
  created() {
    if (this.$route.params.id !== undefined) {
      this.getEventTracks({ eventId: this.$route.params.id, page: 1 })
      this.getEvent(this.$route.params.id)
      this.getEventDateList(this.$route.params.id)
      const bannerQuery = {
        places: ['event_agenda'],
        place_sub_id: this.$route.params.id,
        page: this.filters.page,
      }
      if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
        bannerQuery.chapter_id = this.selectedChips.chapters
      }
      this.getBanner(bannerQuery)
    }
    if (!this.agendaIsoDay) {
      this.agendaIsoDay = this.todayISO()
    }
    const triggerPayload = {
      category: 'Agenda',
      action: 'view_agenda',
      module: 'Events',
      title: 'Agenda',
      id2: this.$route.params.id,
    }
    this.sendTrigger(triggerPayload)
  },
  beforeDestroy() {
    this.clearEventTracks()
    this.clearBanner()
    this.setPageTitle('')
    this.speakerClear()

  },
  mounted() {
    this.setPageTitle('Agenda')
  },

  computed: {
    ...mapGetters('event', [
      'isLoading',
      'pageCountAgendas',
      'agendaEvent',
      'eventTracks',
      'event',
      'dateListEvent',
      'dateListLoading'
    ]),
    ...mapGetters('advertisement', ['banner']),
    ...mapGetters('list', ['sortType']),
    ...mapGetters('app', ['search']),
    eventTimezoneUtc() {
      return this.eventInfo &&
      this.eventInfo.eventTimezone &&
      this.eventInfo.eventTimezone.timezone_utc
          ? this.eventInfo.eventTimezone.timezone_utc
          : 'UTC+0'
    },
    isAgendaDateStrip(){
      return this.event && this.eventStart && this.eventEnd && this.dateListEvent && !this.isSearch && !this.hasSearchText
    },
    eventInfo(){
      if(!this.event){
        return {}
      }
      return this.event.eventView?.find(e => e.block_name === 'eventInfo')?.block_data || {}
    },
    eventStart(){
      if (!this.eventInfo?.event_start) return null
      return this.eventInfo.event_start
    },
    eventEnd(){
      if (!this.eventInfo?.event_end) return null
      return this.eventInfo.event_end

    },
    hasSearchText() {
      return !!this.search?.trim()
    },
    agendaSessionsBlock() {
      return this.agendaEvent.map((agenda) => {
        if (!agenda || !Array.isArray(agenda.sessionsList)) return null
        const block = agenda.sessionsList.find((b) => b.block_name === 'sessionInfo')
        return block ? block.block_data : null
      })
    },
    agendaSessions() {
      const map = new Map()

      this.agendaSessionsBlock.forEach((event) => {
        if (!event?.events_agenda_from) return

        const isoDay = utcTsToIsoDayInEventTz(
            event.events_agenda_from,
            this.eventTimezoneUtc
        )

        if (!map.has(isoDay)) {
          map.set(isoDay, {
            isoDay,
            date: formatEventDayLabel(
                event.events_agenda_from,
                this.eventTimezoneUtc
            ),
            data: [],
          })
        }

        map.get(isoDay).data.push(event)
      })

      return Array.from(map.values())
    }


  },

  data() {
    return {
      pageBlockedName: 'events',
      isSearch: false,
      attrs: {
        elevation: 0,
      },
      agendaIsoDay: null,
    }
  },
}
</script>

<style lang="scss">
.date-wrapper{
  position: sticky;
  top: 64px;
  z-index: 99;
  background-color: #f2f2f2;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  max-width: 555px;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.25s ease;
  &.is-shrunk {
    padding-top: 6px;
    gap: 8px;
    backdrop-filter: blur(6px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
  &__filters{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
.agenda-page {
  background: #f1f1f1 !important;
  font-family: 'Inter', sans-serif;
  &__not-found{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 730px;
    &__text{
      font-family: 'Inter', sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0;
      text-align: center;
      color: #4a4a4a;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    color: #4a4a4a;
    margin-bottom: 8px;
    margin-top: 20px;
  }

  .post {
    &__search {
      background: white;
      height: 54px;
      border-radius: 10px;
      border: 1px solid rgb(230, 230, 230);
      max-width: 600px;
    }

    @media screen and (max-width: 1264px) {
      &__search {
        max-width: none;
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .agenda-page-container {
    max-width: 100%;
    width: 100%;
  }
}

@media screen and (min-width: 1320px) {
  .agenda-page-container {
    max-width: 600px;
  }
}
</style>

